import { render } from "./NewPassword.vue?vue&type=template&id=22b68b0a&ts=true"
import script from "./NewPassword.vue?vue&type=script&lang=ts"
export * from "./NewPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__